/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClockCancel = createReactComponent("clock-cancel", "IconClockCancel", [
  ["path", { d: "M20.997 12.25a9 9 0 1 0 -8.718 8.745", key: "svg-0" }],
  ["path", { d: "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M17 21l4 -4", key: "svg-2" }],
  ["path", { d: "M12 7v5l2 2", key: "svg-3" }]
]);

export { IconClockCancel as default };
//# sourceMappingURL=IconClockCancel.js.map
